import { render, staticRenderFns } from "./LayoutFrontHeader.vue?vue&type=template&id=538a828c&scoped=true&"
import script from "./LayoutFrontHeader.vue?vue&type=script&lang=js&"
export * from "./LayoutFrontHeader.vue?vue&type=script&lang=js&"
import style0 from "./LayoutFrontHeader.vue?vue&type=style&index=0&id=538a828c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "538a828c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('538a828c')) {
      api.createRecord('538a828c', component.options)
    } else {
      api.reload('538a828c', component.options)
    }
    module.hot.accept("./LayoutFrontHeader.vue?vue&type=template&id=538a828c&scoped=true&", function () {
      api.rerender('538a828c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/LayoutFrontHeader.vue"
export default component.exports